import OutlierDetectorEditDto from './OutlierDetectorEditDto';

export class OneClassSvmModelEditDto extends OutlierDetectorEditDto {
	constructor() {
		super();
		/** type {number} */
		this.nu = 0.075;
		/** type {string} */
		this.kernel = null;
		/** type {string} */
		this.gamma = null;
	}

	/**
	 * @typedef {Object} _OneClassSvmModelEditDtoProps
	 * @property {number} nu
	 * @property {string} kernel
	 * @property {string} gamma
	 * 
	 * @typedef {import("./OutlierDetectorEditDto").OutlierDetectorEditDtoProps & _OneClassSvmModelEditDtoProps} OneClassSvmModelEditDtoProps
	 */
	/**
	 *
	 * @param {OneClassSvmModelEditDtoProps} props
	 * @returns {OneClassSvmModelEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.nu = props.nu;
		this.kernel = props.kernel;
		this.gamma = props.gamma;

		return this;
	}
}

export default OneClassSvmModelEditDto;
